import { useMemo } from 'react';
import { useEventFeatureFlags } from '@shared/hooks/useEventFeatureFlags/useEventFeatureFlags';
import { useEventInfo } from '@shared/utils/eventInfo';

type UseWebsiteCustomEventPagesFeatureReturn = Readonly<{
  value: boolean;
  isLoading: boolean;
}>;

/**
 * Hook to determine if custom event pages feature is enabled for the current event.
 * Checks the event-level `useWeddingEventPagesAsCustomPages` feature flag.
 *
 * @returns Object containing:
 * - `value`: boolean indicating if the custom event pages feature is enabled
 * - `isLoading`: boolean indicating if the feature flags are still being loaded
 */
export const useWebsiteCustomEventPagesFeature = (): UseWebsiteCustomEventPagesFeatureReturn => {
  const { eventHandle } = useEventInfo();

  const eventFeatureFlags = useEventFeatureFlags({ eventHandle: eventHandle || '', skip: !eventHandle });
  const isEventEligible = !eventFeatureFlags.loadingEventFeatureFlags && eventFeatureFlags.isEventFeatureFlagEnabled('useWeddingEventPagesAsCustomPages');

  return useMemo(
    () => ({
      value: isEventEligible,
      isLoading: eventFeatureFlags.loadingEventFeatureFlags,
    }),
    [eventFeatureFlags.loadingEventFeatureFlags, isEventEligible],
  );
};
